import { ConnectionState } from "../../models/states/ConnectionState";
import {
    CONNECTION_CONNECTED,
    CONNECTION_DISCONNECTED,
    CONNECTION_ERROR,
    CONNECTION_PROGRESS,
    QUESTIONNAIRE_CHANGED,
    CONNECTION_START,
} from "../actions";
import { ActionTypes } from "../actions/types";

const INITIAL_STATE: ConnectionState = { url: "", connected: false };

export const connectionReducer = (state = INITIAL_STATE, action: ActionTypes) => {
    switch (action.type) {
        case CONNECTION_CONNECTED:
        case CONNECTION_DISCONNECTED:
        case CONNECTION_ERROR:
            return { ...state, connected: action.connected };
        case CONNECTION_PROGRESS:
            return { ...state, progress: action.progress };
        case QUESTIONNAIRE_CHANGED:
            return { ...state, progress: undefined };
        case CONNECTION_START:
            return { url: action.url, connected: false };
        default:
            return state;
    }
};
